function configs(labels, datasets, darkMode) {
    return {
        data: {
            labels,
            datasets: [
                {
                    label: datasets.label,
                    tension: 0.4,
                    pointRadius: 5,
                    pointBorderColor: "transparent",
                    pointBackgroundColor: "#4F8EF7",
                    borderColor: "#4F8EF7",
                    borderWidth: 4,
                    backgroundColor: "rgba(79, 142, 247, 0.10)",
                    fill: true,
                    data: datasets.data,
                    maxBarThickness: 6,
                },
            ],
        },
        options: {
            responsive: true,
            maintainAspectRatio: false,
            plugins: {
                legend: {
                    display: true,
                    labels: {
                        color: darkMode ? "#fff" : "#222",
                        font: { size: 14 }
                    }
                },
                tooltip: {
                    backgroundColor: "#222",
                    titleColor: "#fff",
                    bodyColor: "#fff",
                    borderColor: "#4F8EF7",
                    borderWidth: 2,
                    borderRadius: 8,
                    padding: 12,
                    displayColors: true,
                    caretSize: 8,
                    titleFont: { size: 16, weight: "bold" },
                    bodyFont: { size: 15 },
                    callbacks: {
                        title: function (context) {
                            const label = context[0]?.label || '';
                            return `Dia ${label}`;
                        },
                        label: function (context) {
                            let label = context.dataset.label || '';
                            label = label
                                .toLowerCase()
                                .split(' ')
                                .map(word => word.charAt(0).toUpperCase() + word.slice(1))
                                .join(' ');
                            let value = context.parsed.y !== undefined ? context.parsed.y : context.parsed;

                            if (label === "Sem Rede Ac")
                                label = "Sem Rede AC"

                            return `  ${label}: ${value}`;
                        }
                    }
                }
            },
            interaction: {
                intersect: false,
                mode: "index",
            },
            scales: {
                y: {
                    beginAtZero: true,
                    min: 0,
                    grid: {
                        drawBorder: false,
                        display: true,
                        drawOnChartArea: true,
                        drawTicks: false,
                        borderDash: [4, 4],
                        color: darkMode ? "#444" : "#E0E3EB",
                    },
                    ticks: {
                        display: true,
                        color: darkMode ? "#fff" : "#222",
                        padding: 10,
                        font: {
                            size: 12,
                            weight: 400,
                            family: "Roboto",
                            style: "normal",
                            lineHeight: 2,
                        },
                        stepSize: 1,
                        callback: function (value) {
                            return Number.isInteger(value) ? value : null;
                        }
                    },
                },
                x: {
                    type: 'category',
                    grid: {
                        drawBorder: false,
                        display: false,
                        drawOnChartArea: false,
                        drawTicks: false,
                    },
                    ticks: {
                        display: true,
                        color: darkMode ? "#fff" : "#222",
                        padding: 10,
                        font: {
                            size: 12,
                            weight: 400,
                            family: "Roboto",
                            style: "normal",
                            lineHeight: 2,
                        },
                        autoSkip: false,
                        maxRotation: 0,
                        callback: function (value, index, values) {
                            // Sempre mostra o primeiro e o �ltimo, e de 5 em 5 no meio
                            if (index === 0 || index === labels.length - 1) return labels[index];
                            if (index % 5 === 0) return labels[index];
                            return '';
                        }
                    },
                },
            },
        },
    };
}

export default configs;